import { IDetail } from "../Dashboard/Types";

export enum IPlayerActionTypes {
    GET_PLAYER_RAPID_SEARCH = '@@player/GET_PLAYER_RAPID_SEARCH',
    GET_PLAYER_RAPID_SEARCH_SUCCESS = '@@player/GET_PLAYER_RAPID_SEARCH_SUCCESS',
    GET_PLAYER_RAPID_SEARCH_ERROR = '@@player/GET_PLAYER_RAPID_SEARCH_ERROR',
    
    GET_PLAYER_GROUPS = '@@player/GET_PLAYER_GROUPS',
    GET_PLAYER_GROUPS_SUCCESS = '@@player/GET_PLAYER_GROUPS_SUCCESS',
    GET_PLAYER_GROUPS_ERROR = '@@player/GET_PLAYER_GROUPS_ERROR',

    GET_PLAYER_PERSONS = '@@player/GET_PLAYER_PERSONS',
    GET_PLAYER_PERSONS_SUCCESS = '@@player/GET_PLAYER_PERSONS_SUCCESS',
    GET_PLAYER_PERSONS_ERROR = '@@player/GET_PLAYER_PERSONS_ERROR',
    
    GET_PLAYER_ADVANCED_SEARCH = '@@player/GET_PLAYER_ADVANCED_SEARCH',
    GET_PLAYER_ADVANCED_SEARCH_SUCCESS = '@@player/GET_PLAYER_ADVANCED_SEARCH_SUCCESS',
    GET_PLAYER_ADVANCED_SEARCH_ERROR = '@@player/GET_PLAYER_ADVANCED_SEARCH_ERROR',

    GET_EMISSION_AUTOCOMPLETE = '@@player/GET_EMISSION_AUTOCOMPLETE',
    GET_EMISSION_AUTOCOMPLETE_SUCCESS = '@@player/GET_EMISSION_AUTOCOMPLETE_SUCCESS',
    GET_EMISSION_AUTOCOMPLETE_ERROR = '@@player/GET_EMISSION_AUTOCOMPLETE_ERROR',

    GET_EMISSION_SEARCH = '@@player/GET_EMISSION_SEARCH',
    GET_EMISSION_SEARCH_SUCCESS = '@@player/GET_EMISSION_SEARCH_SUCCESS',
    GET_EMISSION_SEARCH_ERROR = '@@player/GET_EMISSION_SEARCH_ERROR',
    CLEAR_EMISSION_LIST = '@@player/CLEAR_EMISSION_LIST',

    RESET_DATA = '@@player/RESET_DATA',

    SAVE_VIDEO_PLAYER_PARAMS = '@@player/SAVE_VIDEO_PLAYER_PARAMS',
}
export interface IAdvancedSearchPlayerFilters {
    start_date: Date, 
    end_date: Date, 
    time_slot_start: string,
    time_slot_end: string,
    political_group_id?: number,
    political_group_name?:string, 
    person_id?: number, 
    person_name?: string,
    media_ids: number[],
    program_type_ids: number[],
    program_editor_ids: number[],
    isAllMediaSelected: boolean;
    isAllProgramTypesSelected: boolean;
    isAllProgramEditorsSelected: boolean;
    media_str:string[], 
    program_type_str:string[], 
    program_editor_str:string[], 
    study_type_id: number
}
export interface ISummary {
    count: number,
    duration_hms: string,
    duration_s: number
}
export interface IPlayerResults {
    broadcasts: IDetail[];
    summary:ISummary[]
}
export interface IPlayerGroups {
    id: number
    name: string
}
export interface playerPoliticalGroupsFilters {
    media_ids: number[],
    start_date: Date, 
    end_date: Date, 
    time_slot_start: string, 
    time_slot_end: string
}
export interface playerPoliticalPersonFilters {
    media_ids: number[],
    date_start: Date, 
    date_end: Date, 
    time_slot_start: string, 
    time_slot_end: string, 
    political_group_id?:number
}
export interface IEmissionSearchFilters {
    emission_name: string,
    media_ids: number[],
    program_type_ids: number[],
    program_editor_ids: number[],
    isAllMediaSelected: boolean;
    isAllProgramTypesSelected: boolean;
    isAllProgramEditorsSelected: boolean;
    media_str:string[], 
    program_type_str:string[], 
    program_editor_str:string[], 
    date_start: Date,
    date_end: Date,
    study_type_id: number

}

export interface IPlayerRapidSearchFilters {
    media_ids:number[], 
    program_type_ids:number[], 
    program_editor_ids:number[], 
    media_str:string[], 
    program_type_str:string[], 
    program_editor_str:string[], 
    start_date: Date, 
    end_date: Date, 
    person_name: string,
    isAllMediaSelected: boolean;
    isAllProgramTypesSelected: boolean;
    isAllProgramEditorsSelected: boolean;
    study_type_id: number
}

export type ISearchType = 'rapid' | 'emission' | 'advanced'

export interface IPlayerState {
    readonly playerRapidSearchFilters: IPlayerRapidSearchFilters | null;
    readonly playerRapidList: IPlayerResults
    readonly playerAdvancedList: IPlayerResults
    readonly broadcasts: IDetail[]
    readonly summary: ISummary[],
    isLoading: boolean,
    tableLabel: string,
    startDate: Date,
    endDate: Date,
    playerGroups: IPlayerGroups[],
    initialPlayerGroupsID: number[],
    initialPlayerGroupsStr: string[],
    playerPersons: IPlayerGroups[],
    initialPlayerPersonsID: number[],
    initialPlayerPersonsStr: string[],
    advancedSearchPlayerFilters: IAdvancedSearchPlayerFilters | null,
    emissionSearchFilters: IEmissionSearchFilters | null;
    emissions: string[];
    readonly emissionSearchResults: IPlayerResults | null;
    readonly currentSearch: ISearchType;
    videoPlayerStartDate: number;
    videoPlayerEndDate: number;
    mediaID: number;
    expiresAt: number;
    fingerprintID: string | undefined;
    isPlayerGroupsLoading: boolean;
    isEmissionAutocompleteLoading: boolean;
    isPlayerPersonsLoading: boolean;
}
